import {AbstractMapper} from '../../abstract.mapper';
import {HoeheDerBeteiligung, PersonenTypEnum, PersonenTypEnumLabels, StammdatenBeteiligte, WeitereAngabenAnteilseigner} from '@nachdigal';
import {PersonenstammdatenMapperService} from './personenstammdaten-mapper.service';
import {JuristischePersonMapperService} from './juristische-person-mapper.service';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {SteuernummerMapperService} from './steuernummer-mapper.service';
import {Injectable} from '@angular/core';
import {MappedStammdatenAnteilseigner} from '@utils-lib';

@Injectable()
export class AnteilseignerMapperService extends AbstractMapper<StammdatenBeteiligte, MappedStammdatenAnteilseigner> {

    private static readonly PERCENT = 100;
    private static readonly FRACTION_DIGITS = 2;

    constructor(private readonly natuerlichePersonMapper: PersonenstammdatenMapperService,
                private readonly juristischePersonMapper: JuristischePersonMapperService,
                private readonly inlandsadresseMapper: InlandsadresseMapperService,
                private readonly auslandsadresseMapper: AuslandsadresseMapperService,
                private readonly steuernummerMapper: SteuernummerMapperService) {
        super();
    }

    private static mapPersonenTyp(source: StammdatenBeteiligte): PersonenTypEnum {
        if (source.natuerlichePerson) {
            return PersonenTypEnumLabels.NatPers;
        }
        if (source.juristischePerson) {
            return PersonenTypEnumLabels.NNatPers;
        }
        return undefined;
    }

    private static mapWeitereAngaben(source: StammdatenBeteiligte): WeitereAngabenAnteilseigner {
        if (source.natuerlichePerson) {
            return {
                beruflicheTaetigkeit: source.natuerlichePerson.beruf,
                geburtsdatum: source.natuerlichePerson.geburtsdatum,
                identifikationsnummer: source.natuerlichePerson.identifikationsnummer
            };
        } else if (source.juristischePerson) {
            return {
                artDesBetriebes: source.juristischePerson.artDesBetriebs
            };
        } else {
            return undefined;
        }
    }

    //TODO this code is prone to change. It is temporarily made for converting the EUn in the new Mapper
    private static mapBeteiligungNominell(value: number): number {
        if (value && Number(value)) {
            return parseFloat(((Math.round(value * this.PERCENT) / this.PERCENT).toFixed(this.FRACTION_DIGITS)));
        }
        return undefined;
    }

    private static mapHoeheDerBeteiligung(source: StammdatenBeteiligte): HoeheDerBeteiligung {
        return {
            hoeheDerBeteiligungNominell: AnteilseignerMapperService.mapBeteiligungNominell(source.beteiligungBetrag),
            hoeheDerBeteiligungProzent: source.beteiligungProzent
        };
    }

    protected mapInternal(source: StammdatenBeteiligte): MappedStammdatenAnteilseigner {
        return {
            laufendeNummer: source.beteiligtennummer,
            personenTyp: AnteilseignerMapperService.mapPersonenTyp(source),
            natuerlichePerson: this.natuerlichePersonMapper.map(source.natuerlichePerson),
            juristischePerson: this.juristischePersonMapper.map(source.juristischePerson),
            inlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.adressen),
            auslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.adressen),
            steuernummer: this.steuernummerMapper.map(source.steuernummer),
            weitereAngabenAnteilseigner: AnteilseignerMapperService.mapWeitereAngaben(source),
            hoeheDerBeteiligung: AnteilseignerMapperService.mapHoeheDerBeteiligung(source)
        };
    }
}
